import { yupResolver } from "@hookform/resolvers/yup"
import {
  Button,
  Box,
  Divider,
  Flex,
  Picture,
  Typography,
} from "@jewlr/storybook/core"
import { useState } from "react"
import { useForm, Controller } from "react-hook-form"
import styled from "styled-components"
import isEmail from "validator/lib/isEmail"
import * as Yup from "yup"

import api from "apis"
import FloatInput from "components/ui/float-input"
import Textarea from "components/ui/textarea"

import CorporateModal from "./HalfModals/corporate_sales_half_modal"
import {
  Paragraph,
  Section,
  SectionLeft,
  SectionList,
  SectionRight,
  SectionTitle,
} from "./components"
import MainBanner from "./main-banner"

const InputWrapper = styled(Box).attrs({
  flexBasis: { _: "100%", tablet: "50%" },
  mb: { _: 1, tablet: 2 },
})``

const SubmitBtn = styled(Button).attrs({
  variant: "primary",
  width: "100%",
})``

const schema = Yup.object().shape({
  email: Yup.string()
    .required("Please enter a valid email address.")
    .test("test-email", "Please enter a valid email address.", (value) =>
      isEmail(value || "")
    ),
})

const CorporateSales = () => {
  const [submitted, setSubmitted] = useState(false)
  const [showCorporateModal, toggleCorporateModal] = useState(false)

  const {
    control,
    formState: { errors, isSubmitting },
    handleSubmit,
    setError,
  } = useForm({
    defaultValues: {
      company: "",
      email: "",
      firstName: "",
      lastName: "",
      message: "",
      phoneNumber: "",
      website: "",
    },
    mode: "onBlur",
    resolver: yupResolver(schema),
  })

  const onSubmit = async (values) => {
    try {
      let url = `/contact_corporate_sales?first_name=${values.firstName}&last_name=${values.lastName}&email=${values.email}&phone=${values.phoneNumber}&company=${values.company}&website=${values.website}&message=${values.message}&json=true`
      await api.post(url).then((response) => {
        console.log("SENT: ", response)
        setSubmitted(false)
        toggleCorporateModal(true)
      })
    } catch (err) {
      console.log(err)
      setError("root.error", {
        message: err?.errors?.[0] || err?.message || err,
      })
    }
  }

  return (
    <>
      <MainBanner alt="Corporate Sales" src="corporate_sales" />
      <Box contain px={{ _: "10px", tablet: 2 }}>
        <Section>
          <SectionLeft>
            <SectionTitle>Corporate Sales</SectionTitle>
          </SectionLeft>
          <SectionRight>
            <Paragraph>
              Commemorate a milestone, reward exceptional performance, enhance
              your existing loyalty rewards program and unique corporate gift
              ideas. We specialize in creating custom personalized jewelry for
              any occasion based on your corporate needs.
            </Paragraph>
          </SectionRight>
        </Section>
        <Divider mb={5}></Divider>
        <Box display={{ tablet: "flex" }} mb={3} px={{ _: 1, tablet: 0 }}>
          <SectionTitle
            pr={0}
            px={{ _: 0, tablet: 10 }}
            width={{ tablet: 5 / 10 }}
          >
            <Picture
              alt=""
              fallback={require("images/info/corporate_sales/corporatesales-giftcard.jpg")}
              srcSet={[
                {
                  height: 358,
                  media: "(max-width: 767px)",
                  sizes: "100vw",
                  srcSet: `${require("images/info/corporate_sales/m-corporatesales-giftcard.jpg")} 375w, ${require("images/info/corporate_sales/m-corporatesales-giftcard-2x.jpg")} 750w`,
                  width: 375,
                },
                {
                  height: 465,
                  media: "(min-width: 768px)",
                  sizes: "(max-width: 1023px) 192px, 336px",
                  srcSet: `${require("images/info/corporate_sales/corporatesales-giftcard.jpg")} 330w, ${require("images/info/corporate_sales/corporatesales-giftcard-2x.jpg")} 660w`,
                  width: 330,
                },
              ]}
            />
          </SectionTitle>

          <Box width={{ tablet: 5 / 10 }}>
            <SectionTitle mb={0} textAlign="left">
              CORPORATE INCENTIVES
            </SectionTitle>
            <Typography as="p" color="black" fontSize="14px" fontWeight="light">
              Unique corporate gift ideas.
            </Typography>
            <SectionList mb={2}>
              <li>
                Create a custom piece with your corporate logo or brand image
                based on your needs and budget.
              </li>
              <li>
                {" "}
                Ideal for special events, corporate or VIP gifts, client
                recognition, product launches, fundraising keepsake or a
                promotional item.
              </li>
              <li> Elegant custom packaging. </li>
              <li>
                {" "}
                No minimums- We manufacture on demand. Bulk order pricing
                available too.{" "}
              </li>
              <li> Optimized for quick delivery and we ship worldwide. </li>
            </SectionList>
            <SectionTitle mb={0} textAlign="left">
              EMPLOYEE ENGAGEMENT AND RECOGNITION
            </SectionTitle>
            <Typography as="p" color="black" fontSize="14px" fontWeight="light">
              Include Jewlr as part of your overall merchandise incentive
              catalogue.
            </Typography>
            <SectionList mb={2}>
              <li>
                Feature best-selling items in your merchandise catalogue with
                over 2500 SKU’s to choose from.
              </li>
              <li> Create and design exclusive collections.</li>
              <li> Bulk or individual shipments worldwide. </li>
              <li>
                {" "}
                Elegant packaging, gift wrapping or personalized jewelry gift
                box as a keepsake.{" "}
              </li>
              <li>
                {" "}
                We can plug into your online storefront or rewards program
                seamlessly.{" "}
              </li>
              <li>
                {" "}
                Provide employees with Jewlr discounts through your internal
                perks program.{" "}
              </li>
            </SectionList>
            <SectionTitle mb={0} textAlign="left">
              Gift Cards
            </SectionTitle>
            <Typography as="p" color="black" fontSize="14px" fontWeight="light">
              Convenient way to provide an instant reward.
            </Typography>
            <SectionList mb={2}>
              <li>
                Jewlr gift cards are available either as a physical gift card OR
                e-gift card code.
              </li>
              <li> Available in all denominations.</li>
              <li> Our gift cards never expire. </li>
              <li> Pricing discounts based on volume. </li>
              <li> Ease of integration with API. </li>
            </SectionList>
            <SectionTitle mb={0} textAlign="left">
              E-COMMERCE SOLUTIONS
            </SectionTitle>
            <Paragraph>
              We can plug into your online storefront or rewards program
              seamlessly.
            </Paragraph>
            <Paragraph>
              For more information, please contact:{" "}
              <Typography
                as="a"
                color="primary"
                fontSize={16}
                href="mailto:corporatesales@jewlr.com"
              >
                corporatesales@jewlr.com
              </Typography>
            </Paragraph>
          </Box>
        </Box>
        <Divider mb={5}></Divider>
        <Section>
          <SectionLeft textAlign="left" width={{ tablet: 1 / 6 }}>
            <SectionTitle>CONTACT US</SectionTitle>
          </SectionLeft>
          <SectionRight width={{ tablet: 5 / 6 }}>
            <form onSubmit={handleSubmit(onSubmit)}>
              {errors?.root?.error && (
                <Typography color="error" mb={1}>
                  {errors.root.error.message}
                </Typography>
              )}
              <Flex flexWrap="wrap" gutter={1}>
                <InputWrapper>
                  <Controller
                    control={control}
                    name="firstName"
                    render={({ field, fieldState: { error } }) => (
                      <FloatInput
                        autoComplete="given-name"
                        error={error}
                        id="firstName"
                        {...field}
                        label="First Name:"
                      />
                    )}
                  />
                </InputWrapper>

                <InputWrapper>
                  <Controller
                    control={control}
                    name="lastName"
                    render={({ field, fieldState: { error } }) => (
                      <FloatInput
                        autoComplete="family-name"
                        error={error}
                        id="lastName"
                        {...field}
                        label="Last Name:"
                      />
                    )}
                  />
                </InputWrapper>

                <InputWrapper>
                  <Controller
                    control={control}
                    name="email"
                    render={({ field, fieldState: { error } }) => (
                      <FloatInput
                        autoComplete="email"
                        {...field}
                        error={error}
                        id="email"
                        label="Email:"
                      />
                    )}
                  />
                </InputWrapper>
                <InputWrapper>
                  <Controller
                    control={control}
                    name="phoneNumber"
                    render={({ field, fieldState: { error } }) => (
                      <FloatInput
                        autoComplete="tel"
                        {...field}
                        error={error}
                        id="phoneNumber"
                        label="Phone Number:"
                      />
                    )}
                  />
                </InputWrapper>

                <InputWrapper>
                  <Controller
                    control={control}
                    name="company"
                    render={({ field, fieldState: { error } }) => (
                      <FloatInput
                        autoComplete="organization"
                        {...field}
                        error={error}
                        id="company"
                        label="Company:"
                      />
                    )}
                  />
                </InputWrapper>
                <InputWrapper>
                  <Controller
                    control={control}
                    name="website"
                    render={({ field, fieldState: { error } }) => (
                      <FloatInput
                        autoComplete="url"
                        {...field}
                        error={error}
                        id="website"
                        label="Website:"
                      />
                    )}
                  />
                </InputWrapper>

                <Box flexBasis="100%" mb={2}>
                  <Controller
                    control={control}
                    name="message"
                    render={({ field, fieldState: { error } }) => (
                      <Textarea
                        error={error}
                        id="message"
                        placeholder="Message:"
                        rows="5"
                        {...field}
                      />
                    )}
                  />
                </Box>

                <Box width="100%">
                  <SubmitBtn
                    disabled={isSubmitting}
                    loading={isSubmitting}
                    type="submit"
                  >
                    {submitted ? "Sent" : "Send"}
                  </SubmitBtn>
                </Box>
              </Flex>
            </form>
          </SectionRight>
        </Section>
        <CorporateModal
          showCorporateModal={showCorporateModal}
          toggleCorporateModal={toggleCorporateModal}
        />

        <Divider mb={5}></Divider>
        <Section>
          <SectionLeft textAlign="left" width={{ tablet: 1 / 6 }}>
            <SectionTitle>GET IN TOUCH</SectionTitle>
          </SectionLeft>
          <SectionRight width={{ tablet: 5 / 6 }}>
            <Typography
              as="p"
              color="black"
              fontSize="14px"
              fontWeight="normal"
              letterSpacing="1.25px"
            >
              For more information regarding{" "}
              <strong>Jewlr Corporate Sales</strong> please contact:
            </Typography>

            <Paragraph mb={0}>
              Email:{" "}
              <Typography
                as="a"
                color="primary"
                fontSize={16}
                href="mailto:corporatesales@jewlr.com"
              >
                corporatesales@jewlr.com
              </Typography>
            </Paragraph>
          </SectionRight>
        </Section>
        <Divider mb={5}></Divider>
      </Box>
    </>
  )
}
CorporateSales.propTypes = {}

export default CorporateSales
